import axios from "axios";

export default {
  namespaced: true,
  state: {
    paymethods: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    paymethodsMessage: ''
  },
  mutations: {
    CLEAR_PAYMETHODS(state) {
      state.paymethods = [];
    },
    RECEIVED_PAYMETHODS(state, payload) {
      state.paymethods = payload;
      state.isReceiving = false;
    },
    RECEIVING_PAYMETHODS(state) {
      state.isReceiving = true;
    },
    RECEIVED_PAYMETHOD(state, payload) {
      state = Object.assign(state, {
        paymethods: [...state.paymethods, payload],
        isReceiving: false,
      })
    },
    RECEIVING_PAYMETHOD(state) {
      state.isReceiving = true;
    },
    UPDATED_PAYMETHOD(state, payload) {
      let index = state.paymethods.findIndex(paymethod => paymethod._id === payload._id);
      state = Object.assign(state, {
        paymethods: state.paymethods.map((paymethod, i) => {
          if (i === index) {
            return Object.assign({}, paymethod, payload);
          }
          return paymethod;
        }),
        isUpdating: false,
        paymethodsMessage: 'PayMethods has been updating!',
      })
    },
    UPDATING_PAYMETHOD(state) {
      state.isUpdating = true;
    },
    DELETED_PAYMETHOD(state, payload) {
      let indexToDelete = state.paymethods.findIndex(paymethod => paymethod._id === payload._id);
      let paymethods = [...state.paymethods];
      paymethods.splice(indexToDelete, 1);
      state = Object.assign(state, {
        paymethods: [...paymethods],
        isDeleting: false,
        idToDelete: null,
        paymethodsMessage: 'PayMethod has been Deleted!',
      });
    },
    DELETING_PAYMETHOD(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deletePayMethodRequest({dispatch}, payload) {
      dispatch("deletingPayMethod", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/paymethod/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deletePayMethod", {_id: payload._id});
      })
    },
    async getPayMethodsRequest({dispatch}) {
      dispatch("receivingPayMethods");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/paymethods';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(res => {
        console.log(res.data)
        dispatch("receivePayMethods", res.data);
      })
    },
    async insertPayMethodRequest({dispatch}, payload) {
      dispatch("receivingPayMethods");
      let url;
      let data;
      let token = localStorage.getItem('token');
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      if(payload.imagefile !== undefined) {
        url = 'https://api.accountxc.com:3100/insert/paymethod/withimage';
        data = new FormData();
        data.append('image', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) {data.append(x, payload[x]);}
      } else {
        url = 'https://api.accountxc.com:3100/insert/paymethod';
        data = payload;
      }
      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receivePayMethod", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    updatePayMethodRequest({dispatch}, payload) {
      dispatch("updatingPayMethod");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/paymethod/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updatePayMethod", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updatePayMethodImageRequest({dispatch}, payload) {
      dispatch("updatingPayMethod");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      var url = 'https://api.accountxc.com:3100/update/paymethod/image/' + id;
      let data = new FormData();
      data.append('image', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updatePayMethod", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updatePayMethodQrRequest({dispatch}, payload) {
      dispatch("updatingPayMethod");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      var url = 'https://api.accountxc.com:3100/update/paymethod/qr/' + id;
      let data = new FormData();
      data.append('image', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updatePayMethod", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },


    clearPayMethods({commit}) {
      commit("CLEAR_PAYMETHODS")
    },
    receivePayMethods({commit}, payload) {
      commit("RECEIVED_PAYMETHODS", payload)
    },
    receivingPayMethods({commit}) {
      commit("RECEIVING_PAYMETHODS")
    },
    receivePayMethod({commit}, payload) {
      commit("RECEIVED_PAYMETHOD", payload)
    },
    receivingPayMethod({commit}) {
      commit("RECEIVING_PAYMETHOD")
    },
    updatePayMethod({commit}, payload) {
      commit("UPDATED_PAYMETHOD", payload)
    },
    updatingPayMethod({commit}) {
      commit("UPDATING_PAYMETHOD")
    },
    deletePayMethod({commit}, payload) {
      commit("DELETED_PAYMETHOD", payload)
    },
    deletingPayMethod({commit}, payload) {
      commit("DELETING_PAYMETHOD", payload)
    }
  },
};
